// extracted by mini-css-extract-plugin
export default {"innerWrapper":"st-z","tooltipWrapper":"tt-z","icon":"ut-z","tooltip":"vt-z","content":"wt-z"};